<template>
  <div class="full">
    <md-card>
      <md-card-header>
        <md-whiteframe md-tag="md-toolbar" md-elevation="2" class="md-medium">
          <div class="md-toolbar-container"></div>
          <div class="md-toolbar-container">
            <h2 class="md-title">Adicionar Solicitações</h2>
            <router-link to="/">
              <md-button class="md-fab md-fab-cancel">
                <md-icon>clear</md-icon>
                <md-tooltip md-direction="top">Cancelar</md-tooltip>
              </md-button>
            </router-link>

            <md-button @click="openSaveDialog" id="save" class="md-fab md-fab-save">
              <md-icon>done</md-icon>
              <md-tooltip md-direction="top">Salvar</md-tooltip>
            </md-button>
          </div>
        </md-whiteframe>
      </md-card-header>

      <md-card-content class="scrolable">

        <div class="md-subheading">
          {{issues.created}}
        </div>

        <md-layout md-gutter="16"> 
          <md-layout md-flex="70"> 
            <md-input-container>
              <label>Título</label>
              <md-textarea v-model="issues.summaryFormat" placeholder="Padrão: [Cliente] - [Placa]"></md-textarea>
            </md-input-container>
          </md-layout>

          <md-layout md-flex="30"> 
            <md-chip @edit="insertKeyOnSummary(key)" class="align-to-field" md-editable v-for="(value, key) in issues.summaryOptions" :key="key">
              {{value}}
            </md-chip>
          </md-layout>
        </md-layout>

        <md-layout md-align="center">
          <div class="md-caption">
            {{exampleMessage}}
          </div>
        </md-layout>

        <md-input-container :class="{ 'md-input-invalid' : issues.hasDescriptionError && !issues.description}">
          <label>Descrição</label>
          <md-textarea v-model="issues.description" required></md-textarea>
        </md-input-container>

        <md-layout md-gutter="16" v-for="(vehicleTicket, i) in issues.vehicleTickets" :key="i">
          <md-layout md-flex>
            <md-input-container :class="{ 'md-input-invalid' : vehicleTicket.hasPlateError}">
              <label>Placa</label>
              <md-autocomplete v-model="vehicleTicket.plate"
                              :fetch="findVehiclesByPlateFetch"
                              :print-attribute="'plate'"
                              @selected="isPlatesInTickets"
                              :debounce="700">
              </md-autocomplete>
              <span class="md-error">{{vehicleTicket.messageError}}</span>
            </md-input-container>
          </md-layout>
         
          <md-layout md-flex>
            <md-input-container :class="{ 'md-input-invalid' : vehicleTicket.hasIssuetypeError && !vehicleTicket.issuetype}">
              <label>Motivo</label>
              <md-select required v-model="vehicleTicket.issuetype" @selected="updateLastSelected">
                <md-option v-for="issueType in issueTypes" :value="issueType" :key="issueType">{{issueType}}</md-option>
              </md-select>
            </md-input-container>
          </md-layout>
          
          <md-layout md-flex="10">
            <md-button @click="removeVehicle(vehicleTicket)" class="md-icon-button md-warn align-to-field">
              <md-icon>cancel</md-icon>
            </md-button>
          </md-layout>
        </md-layout>
        <md-button @click="addVehicle" class="md-primary md-raised">Adicionar Veiculo</md-button>

      </md-card-content>
    </md-card>

    <md-snackbar :md-position="snack.vertical + ' ' + snack.horizontal" ref="snackbar" :md-duration="snack.duration">
      <span>{{snack.message}}</span>
      <md-button class="md-accent" @click="$refs.snackbar.close()">Ok</md-button>
    </md-snackbar>

    <md-dialog md-open-from="#wait" md-close-to="#wait" ref="wait">
      <md-dialog-title>Aguarde ...</md-dialog-title>

      <md-dialog-content>
        <md-progress md-indeterminate></md-progress>
      </md-dialog-content>
    </md-dialog>

    <md-dialog md-open-from="#save" md-close-to="#save" ref="save">
      <md-dialog-title>Tem certeza que deseja salvar estes tickets?</md-dialog-title>

      <md-dialog-content></md-dialog-content>

      <md-dialog-actions>
        <md-button class="md-primary" @click="closeSaveDialog()">Não</md-button>
        <md-button class="md-primary" @click="saveTickets()">Sim</md-button>
      </md-dialog-actions>
    </md-dialog>
  </div>
</template>

<script>
  import moment from "moment/moment";
  import ticketsService from "../services/TicketsService"
  import AuthService from "../services/AuthService";
  import Vue from "vue"
  import router from "../router/index";
  import debounce from "debounce"

  export default {

    data(){
      return{
        issues : {
          created: null,
          description: null,
          summaryFormat: "%customer% - %plate%",
          vehicleTickets: [
            {serial: null, plate: null, issuetype: null}
          ],
          summaryOptions: {
            "%plate%": "Placa",
            "%code%": "Código",
            "%organization%": "Organização",
            "%customer%": "Cliente"
          }
        },

        issueTypes:[
          "(Des)instalação/Remanejamento",
          "Falha no equipamento",
          "Falha de transmissão",
          "Cadastros no sistema",
          "Dúvida Geral",
          "Outros"
        ],

        vehicles: [],

        lastSelected : null,
        snack:{
          vertical: 'bottom',
          horizontal: 'center',
          duration: 4000,
          message: null
        },

        exampleSummary: {
          message: null,
          "%plate%": "PPP-9999",
          "%organization%": "Organização X",
          "%customer%": "Cliente Y",
          "%code%": "COD12"
        }
      }

    },

    created(){
      moment.locale('pt-br');
      this.issues.created = moment().format('L');
    },

    methods:{
      filter(list, string) {
        console.log(list);
        return () => {
          return list;
        };
      },

      addVehicle : function () {
        this.issues.vehicleTickets.push({plate: null, issuetype: this.lastSelected});
      },

      removeVehicle : function(vehicleTicket){
        var i = this.issues.vehicleTickets.indexOf(vehicleTicket);
        this.issues.vehicleTickets.splice(i, 1);
      },

      filterVehicles : function(vehicles, plate){
        return function () {
          var v = vehicles.filter(function (vehicle) {
            return vehicle.plate.toLowerCase().indexOf(plate.toLowerCase()) !== -1;
          });
          return v;
        }
      },

      findVehiclesByPlateFetch : function(query) {
        if(query.q && query.q !== "") {
          return ticketsService.findVehiclesByPlate(query.q).then((success) => {
            if (success.body.length === 1){
              this.isPlatesInTickets(success.body[0], success.body[0].plate)
              return [];
            }
            return success.body;
          });
        }
      },

      isPlatesInTickets : function (vehicle, plate) {
        this.issues.vehicleTickets.forEach(vehicleTicket => {
          if(vehicleTicket.plate.toUpperCase() === plate.toUpperCase()){
            vehicleTicket.code = vehicle.code;
            vehicleTicket.equipment = vehicle.equipment;
            vehicleTicket.organization = vehicle.organization;
            vehicleTicket.hasPlateError = false;
            vehicleTicket.messageError = "";
          }
        });
        vehicle.hasPlateError = false;
        vehicle.messageError = "";
        ticketsService.isPlatesInTickets(plate).then((success) => {

        }, (error) => {
          this.issues.vehicleTickets.forEach(vehicleTicket => {
            if(vehicleTicket.plate === plate){
              vehicleTicket.hasPlateError = true;
              vehicleTicket.messageError = error.bodyText;
            }
          });
          vehicle.hasPlateError = true;
          vehicle.messageError = error.bodyText;
          this.snack.message = error.bodyText;
          this.openSnack();
        });
      },

      validateTickets : function () {
        if(!this.issues.description || this.issues.description === ''){
          this.issues.hasDescriptionError = true;
          this.snack.message = 'O campo descrição não pode ser vazio';
          this.openSnack();
          return false;
        }
        if(this.issues.vehicleTickets.length === 0){
          this.snack.message = 'Selecione ao menos um veículo';
          this.openSnack();
          return false;
        }
        var i;
        for(i in this.issues.vehicleTickets){
          if(this.issues.vehicleTickets[i].hasPlateError === true){
            this.snack.message = 'Remova as placas que já possuem Tickets abertos';
            this.openSnack();
            return false;
          }
          if(!this.issues.vehicleTickets[i].plate || this.issues.vehicleTickets[i].plate === ''){
            this.issues.vehicleTickets[i].hasPlateError = true;
            this.snack.message = 'Selecione um veículo ou remova o ticket';
            this.openSnack();
            return false;
          }
          if(!this.issues.vehicleTickets[i].issuetype){
            this.issues.vehicleTickets[i].hasIssuetypeError = true;
            this.snack.message = 'Selecione um motivo para cada placa';
            this.openSnack();
            return false;
          }
        }
        return true;
      },

      saveTickets : function () {
        var isValid = this.validateTickets();
        this.closeSaveDialog();
        if(isValid === true){
          this.openWaitDialog();
          ticketsService.createInternalTickets(this.issues).then((success) => {
            router.push({path: '/'})
          }, (failure) =>{
            this.closeWaitDialog();
            this.snack.message = failure.bodyText;
            this.openSnack();
          });
        }
      },

      updateLastSelected : function (selected) {
        this.lastSelected = selected;
      },

      openSnack : function() {
        this.$refs.snackbar.close();
        this.$refs.snackbar.open();
      },

      openWaitDialog : function() {
        this.$refs.wait.open();
      },

      closeWaitDialog : function() {
        this.$refs.wait.close();
      },

      openSaveDialog : function(){
        this.$refs.save.open();
      },

      closeSaveDialog : function(){
        this.$refs.save.close();
      },

      insertKeyOnSummary : function(key){
        this.issues.summaryFormat = this.issues.summaryFormat + " " + key;
      },
    },

    computed: {
      exampleMessage: function () {
        this.exampleSummary.message = this.issues.summaryFormat;

        for(var sampleKey in this.exampleSummary){
          this.exampleSummary.message = this.exampleSummary.message.replace(new RegExp(sampleKey, 'g'), this.exampleSummary[sampleKey])
        }
        return this.exampleSummary.message
      }
  }

  }
</script>

<style>
  .scrolable{
    position: relative;
    max-height: 400px;
    overflow-y: scroll;
  }

  .md-fab-save {
    margin: 0;
    position: absolute !important;
    bottom: -28px;
    right: 26px;
  }

  .md-fab-cancel {
    margin: 0;
    position: absolute !important;
    bottom: -28px;
    right: 90px;
  }

  .align-to-field{
    margin-top: 15px !important;
  }

</style>



// WEBPACK FOOTER //
// src/components/CreateTickets.vue